import { Lit3formBlock, html } from '@Root/lib/lit-3form-block';

// Deprecated. Legacy CMS pages still reference <jesse-block>, so the custom
// element must remain defined — but it renders nothing. Walter is the live
// replacement; walter/customize-material-barrel removes any lingering
// <jesse-block> when it mounts on modern pages.
export class Jesse extends Lit3formBlock {
  static get characterName() {
    return 'jesse';
  }

  render() {
    return html``;
  }
}

Jesse.defineElement();
